/* Copyright (C) ZibatRan, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Zibatran development team, Dec 2020
 */

import React, {useEffect} from 'react';
import {Redirect, Route, BrowserRouter as Router, Switch} from "react-router-dom";
import PublicLayout from "./components/public/main/PublicLayout";
import VideogramItem from "./pages/public/VideogramItem";
import Features from "./pages/public/Features";
import VideogramList from "./pages/public/VideogramList";
import EventList from "./pages/public/EventList";
import EventItem from "./pages/public/EventItem";
import CheckOut from "./pages/public/CheckOut";
import UserPublicProfile from "./pages/public/UserPublicProfile";

const ViewAuthentication = React.lazy(() =>
    import('./pages/authentication')
);
const ViewDashboard = React.lazy(() =>
    import('./pages/dashboard')
);
const ViewAdmin = React.lazy(() =>
    import('./pages/admin')
);
const MainPage = React.lazy(() =>
    import( './pages/public/Main')
);
const FAQPage = React.lazy(() =>
    import( './pages/public/FAQ')
);
const PolicyPage = React.lazy(() =>
    import( './pages/public/Policies')
);
const AboutPage = React.lazy(() =>
    import( './pages/public/About')
);

const SchoolPage = React.lazy(() =>
    import( './pages/public/School')
);
const SchoolContentsDetailPage = React.lazy(() =>
    import( './pages/public/SchoolContentsDetail')
);
const SchoolContentsListPage = React.lazy(() =>
    import( './pages/public/SchoolContentsList')
);
const SendFestivalArtEffectsPage = React.lazy(() =>
    import( './pages/public/SendFestivalArtEffects')
);
const SchoolFestivalEffectsListPage = React.lazy(() =>
    import( './pages/public/SchoolFestivalEffectsList')
);
const SchoolFestivalEffectDetailPage = React.lazy(() =>
    import( './pages/public/SchoolFestivalEffectDetail')
);


if(localStorage.getItem("zibatran-user-data") && !JSON.parse(localStorage.getItem("zibatran-user-data")).hasOwnProperty('access_token')){
    localStorage.removeItem('zibatran-user-data');
}


function App() {


    useEffect(() => {
        console.log("Copyright (C) ZibatRan, Inc - All Rights Reserved \n" +
            "Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential \n" +
            "Written by Zibatran development team, Dec 2020"
        )
    }, []);

    const AuthRoute = ({component: Component, ...rest}) => {
        // console.log(isUserLogin);
        return (
            <Route
                {...rest}
                render={(props) =>
                    localStorage.getItem("zibatran-user-data") && JSON.parse(localStorage.getItem("zibatran-user-data")).code !== "" ?
                        <Component {...props} />
                        :
                        <Redirect
                            to={{
                                pathname: '/auth',
                                state: {from: props.location},
                            }}
                        />

                }
            />
        );
    };


    return (
        <div className="mainContainer">
            <Router>
                <Switch>
                    <AuthRoute
                        path="/dashboard"
                        component={(props) => <ViewDashboard {...props}/>}
                    />

                    <AuthRoute
                        path="/admin"
                        component={(props) => <ViewAdmin {...props}/>}
                    />
                    <Route
                        path={"/auth"}
                        render={(props) => <ViewAuthentication {...props} />}
                    />


                    <PublicLayout>


                        <Switch>
                            <Route
                                path={`/policy`}
                                render={(props) => <PolicyPage {...props} />}
                            />
                            <Route
                                path={`/faq`}
                                render={(props) => <FAQPage {...props} />}
                            />
                            <Route
                                path={`/about`}
                                render={(props) => <AboutPage {...props} />}
                            />

                            <Route
                                path={`/features`}
                                render={(props) => <Features {...props} />}
                            />


                            <Route
                                path={`/school/:category/detail/:username/send-effects/:festivalid/:hostid`}
                                render={(props) => <SendFestivalArtEffectsPage {...props} />}
                            />

                            <Route
                                path={`/school/festival/effect/:id/:effectid`}
                                render={(props) => <SchoolFestivalEffectDetailPage {...props} />}
                            />
                            <Route
                                path={`/school/festival/effects/:id`}
                                render={(props) => <SchoolFestivalEffectsListPage {...props} />}
                            />
                            <Route
                                path={`/school/:category/detail/:username/:id`}

                                render={(props) => <SchoolContentsDetailPage {...props} />}
                            />
                            <Route
                                path={`/school/:category/:username`}

                                render={(props) => <SchoolContentsListPage {...props} />}
                            />
                            <Route
                                path={`/school/:id`}

                                render={(props) => <SchoolPage {...props} />}
                            />

                            <Route
                                path={`/videogram-list`}

                                render={(props) => <VideogramList {...props} />}
                            />

                            <Route
                                path={`/videogram/:id`}

                                render={(props) => <VideogramItem {...props} />}
                            />
                            <Route
                                path={`/event-list`}

                                render={(props) => <EventList {...props} />}
                            />
                            <Route
                                path={`/event/:id`}

                                render={(props) => <EventItem {...props} />}
                            />
                            <Route
                                path={`/checkout/event/:id`}

                                render={(props) => <CheckOut {...props} />}
                            />

                            <Route
                                path={`/user/:id`}

                                render={(props) => <UserPublicProfile {...props} />}
                            />

                            <Route 
                                exact path="/">

                               <Redirect to="/dashboard/main" />
                            </Route>

                        </Switch>

                    </PublicLayout>

                </Switch>
            </Router>
        </div>
    );


}

export default App;
